import React, { useState } from "react";
import {
  Container,
  Card,
  Button,
  Form,
  Row,
  Col,
  Alert,
  InputGroup
} from "react-bootstrap";

function AdminLogin({ onLogin, onSwitchRole }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('/api/admin/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });
    const data = await response.json();
    if (response.ok) {
      setError('');
 localStorage.setItem("admin", JSON.stringify(data.admin));
localStorage.setItem("authToken", data.token);   // <-- add this line!
if (onLogin) onLogin(data.admin);


    } else {
      setError(data.message || "Invalid admin credentials.");
    }
  } catch (err) {
    setError("Network error. Please try again.");
  }
  // --- END OF UPDATED LOGIN LOGIC ---
};

  return (
  <>
    {/* Top Right Change Role Button */}
<Button
  style={{
    backgroundColor: "#2b67cfff", // or any color you want
    color: "#fff",
    fontWeight: 600,
    borderRadius: "8px",
    boxShadow: "0 1px 5px rgba(226, 226, 227, 0.08)",
    position: "absolute", top: 20, right: 30, zIndex: 1000
  }}
  onClick={onSwitchRole}
>
  Change Role
</Button>


    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Row className="w-100 justify-content-center">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow p-4">
            <Card.Body>
              <h3 className="mb-4 text-center">Admin Login</h3>
              <Form onSubmit={handleLogin}>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter admin or staff email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group controlId="formPassword" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter password"
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassword((prev) => !prev)}
                      tabIndex={-1}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </Button>
                    
                  </InputGroup>
                </Form.Group>
                {error && <Alert variant="danger">{error}</Alert>}
                <div className="d-grid">
                  <Button variant="primary" type="submit">
                    Login
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </>
);

}

export default AdminLogin;
